import { useEffect, useState } from 'react';

/**
 * Return the correct image size for the hotspot image.
 */
export const useHotspotImageSize = (src: string) => {
  const [width, setWidth] = useState('100%');

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      const { height, width } = img;

      if (height > width) {
        const newWidth = (width / height) * 600;

        setWidth(`${newWidth}px`);
      }
    };

    img.src = src;

    return () => {
      img.onload = null;
    };
  }, [src]);

  return width;
};
